var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_58_10960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5198 16.4994C15.5198 17.7048 14.8102 18.6444 13.5046 19.3098C12.1866 19.9816 10.3205 20.3334 8.20763 20.3334C6.11721 20.3334 4.25084 19.8711 2.9251 19.1399C1.58436 18.4004 0.895508 17.4513 0.895508 16.4994C0.895508 12.461 4.16926 9.18726 8.20763 9.18726C12.246 9.18726 15.5198 12.461 15.5198 16.4994Z",
    fill: "#E8F2FD",
    stroke: "#4C5B66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1957 4.98957C12.1957 6.10303 11.7401 7.3141 10.9916 8.24463C10.2425 9.17592 9.25126 9.76753 8.20783 9.76753C7.1644 9.76753 6.17314 9.17592 5.42404 8.24463C4.67555 7.3141 4.21997 6.10303 4.21997 4.98957C4.21997 2.78713 6.0054 1.00171 8.20783 1.00171C10.4103 1.00171 12.1957 2.78713 12.1957 4.98957Z",
    fill: "#E8F2FD",
    stroke: "#4C5B66"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_58_10960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6479 22.9458C22.6479 24.4629 21.7507 25.635 20.1416 26.4551C18.5202 27.2815 16.2349 27.7101 13.6589 27.7101C11.1054 27.7101 8.81986 27.1456 7.19066 26.2471C5.54647 25.3403 4.66992 24.1586 4.66992 22.9458C4.66992 17.9813 8.69444 13.9568 13.6589 13.9568C18.6234 13.9568 22.6479 17.9813 22.6479 22.9458Z",
    fill: "#59A5EE",
    stroke: "#4C5B66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6101 8.96523C18.6101 10.3447 18.0467 11.839 17.1239 12.9863C16.2005 14.1343 14.9684 14.8761 13.659 14.8761C12.3495 14.8761 11.1174 14.1343 10.194 12.9863C9.27117 11.839 8.70776 10.3447 8.70776 8.96523C8.70776 6.23076 10.9245 4.01404 13.659 4.01404C16.3934 4.01404 18.6101 6.23076 18.6101 8.96523Z",
    fill: "#59A5EE",
    stroke: "#4C5B66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_58_10960",
    x: 0.395508,
    y: 0.501709,
    width: 15.6243,
    height: 20.3317,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_58_10960"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_58_10960",
    x: 4.16992,
    y: 3.51404,
    width: 18.978,
    height: 24.696,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_58_10960"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.cc51c9d3425641391fb2fa6327631958.svg";
export { ForwardRef as ReactComponent };